/**
 * The purpose of these values is to help with identifying when
 * black text should be shown for the PREVIOUS and NEXT buttons on the
 * PSG brand page. We're currently hardcoding as the CMS pod does not have
 * capacity to add this into the space at the moment
 */
export const PSG_BLACK_BUTTONS = {
  '0': true,
  '1': true,
  '2': true,
  '3': true,
  '7': true,
  '8': true,
  '9': true,
  '11': true,
  '12': true,
  '13': true,
  '15': true,
};
